// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"61811df31fefd3571bd3","293":"7e84fd2251ed39fb8bab","461":"af699003e9ce28763356","518":"6cd76eaec4b99e93758b","779":"1794276fa581608c7841"}[chunkId] + ".js";
};